import axiosInstance from 'api/axiosInstance';

export interface TicketStats {
	totalTickets: string;
	logTickets: string;
	logAndWarnTickets: string;
	towTickets: string;
}

export const getTicketStatsForParkingLocation = async (
	parkingLocationId: string,
	startDate: Date,
	endDate: Date,
): Promise<TicketStats> => {
	try {
		// Convert Date objects to ISO strings for the API call
		const utcStartISO = startDate.toISOString();
		const utcEndISO = endDate.toISOString();

		// Construct the API URL with query parameters
		const API_URL = `/api2.0/tickets/getTicketStatsForParkingLocation`;
		const response = await axiosInstance.get(API_URL, {
			params: {
				parkingLocationId,
				utcStart: utcStartISO,
				utcEnd: utcEndISO,
			},
		});

		// ✅ Ensure response has the required fields
		const stats: TicketStats = {
			totalTickets: response.data.totalTickets || 0,
			logTickets: response.data.logTickets || 0,
			logAndWarnTickets: response.data.logAndWarnTickets || 0,
			towTickets: response.data.towTickets || 0,
		};

		return stats;
	} catch (error) {
		console.error(
			`❌ Error fetching ticket stats for parking location ${parkingLocationId}:`,
			error,
		);
		throw error;
	}
};
